import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type IWidgetOptionValue } from '../../../../Widget.ts';
import { DraggableActionsButton } from './style/DraggableActionsButton.tsx';
import { WidgetOptionStructure } from './style/WidgetOptionStructure.tsx';

const OptionCol = styled.div`
  width: 70%;
  padding: 0 4px;
`;
const ValueCol = styled.div`
  width: 30%;
  font-family: monospace;
  font-weight: 600;
  padding: 0 4px;
`;

export interface IWidgetOptionValueViewProps {
  item: IWidgetOptionValue;
  listeners?: any;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function WidgetOptionValueView(props: IWidgetOptionValueViewProps) {
  const { item, listeners, ...actions } = props;

  return (
    <WidgetOptionStructure
      listeners={listeners}
      actions={<DraggableActionsButton {...actions} />}
    >
      <OptionCol>
        <RichTextAdvancedRender inline text={item.label} />
      </OptionCol>
      <ValueCol>{item.value}</ValueCol>
    </WidgetOptionStructure>
  );
}
